import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';

type WindowSize = {
  width?: number;
  height?: number;
};

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    const debouncedHandler = debounce(handleResize, 200);
    window.addEventListener('resize', debouncedHandler);
    handleResize();
    return () => window.removeEventListener('resize', debouncedHandler);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
};

export default useWindowSize;
